/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FuelUpVaultActionResponseEvolutionResult } from './FuelUpVaultActionResponseEvolutionResult';
import {
    FuelUpVaultActionResponseEvolutionResultFromJSON,
    FuelUpVaultActionResponseEvolutionResultFromJSONTyped,
    FuelUpVaultActionResponseEvolutionResultToJSON,
    FuelUpVaultActionResponseEvolutionResultToJSONTyped,
} from './FuelUpVaultActionResponseEvolutionResult';
import type { FuelUpVaultState } from './FuelUpVaultState';
import {
    FuelUpVaultStateFromJSON,
    FuelUpVaultStateFromJSONTyped,
    FuelUpVaultStateToJSON,
    FuelUpVaultStateToJSONTyped,
} from './FuelUpVaultState';
import type { FuelUpVaultTransaction } from './FuelUpVaultTransaction';
import {
    FuelUpVaultTransactionFromJSON,
    FuelUpVaultTransactionFromJSONTyped,
    FuelUpVaultTransactionToJSON,
    FuelUpVaultTransactionToJSONTyped,
} from './FuelUpVaultTransaction';

/**
 * 
 * @export
 * @interface FuelUpVaultActionResponse
 */
export interface FuelUpVaultActionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FuelUpVaultActionResponse
     */
    success: boolean;
    /**
     * 
     * @type {FuelUpVaultState}
     * @memberof FuelUpVaultActionResponse
     */
    vault: FuelUpVaultState;
    /**
     * 
     * @type {FuelUpVaultTransaction}
     * @memberof FuelUpVaultActionResponse
     */
    transaction: FuelUpVaultTransaction;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultActionResponse
     */
    userFuelBalance?: number;
    /**
     * 
     * @type {FuelUpVaultActionResponseEvolutionResult}
     * @memberof FuelUpVaultActionResponse
     */
    evolutionResult?: FuelUpVaultActionResponseEvolutionResult;
}

/**
 * Check if a given object implements the FuelUpVaultActionResponse interface.
 */
export function instanceOfFuelUpVaultActionResponse(value: object): value is FuelUpVaultActionResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('vault' in value) || value['vault'] === undefined) return false;
    if (!('transaction' in value) || value['transaction'] === undefined) return false;
    return true;
}

export function FuelUpVaultActionResponseFromJSON(json: any): FuelUpVaultActionResponse {
    return FuelUpVaultActionResponseFromJSONTyped(json, false);
}

export function FuelUpVaultActionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpVaultActionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'vault': FuelUpVaultStateFromJSON(json['vault']),
        'transaction': FuelUpVaultTransactionFromJSON(json['transaction']),
        'userFuelBalance': json['userFuelBalance'] == null ? undefined : json['userFuelBalance'],
        'evolutionResult': json['evolutionResult'] == null ? undefined : FuelUpVaultActionResponseEvolutionResultFromJSON(json['evolutionResult']),
    };
}

export function FuelUpVaultActionResponseToJSON(json: any): FuelUpVaultActionResponse {
    return FuelUpVaultActionResponseToJSONTyped(json, false);
}

export function FuelUpVaultActionResponseToJSONTyped(value?: FuelUpVaultActionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'vault': FuelUpVaultStateToJSON(value['vault']),
        'transaction': FuelUpVaultTransactionToJSON(value['transaction']),
        'userFuelBalance': value['userFuelBalance'],
        'evolutionResult': FuelUpVaultActionResponseEvolutionResultToJSON(value['evolutionResult']),
    };
}

